import { Button, styled, Typography } from "@material-ui/core";
import React from "react";
import {STEP_TABS} from "./constants";

const Wrapper = styled("div")(({ theme }) => ({
  minWidth: 500,
  minHeight: 250,
  color:'var(--dark_blue)',

  "& .modalHeader": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    borderBottom: "1px solid #d3d3d3",

    "& .titleWrapper": {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },

    "& .titleHeader": {
      fontSize: "20px",
      fontWeight: 600,
    },
  },

  "& .modalBody": {
    padding: 16,
    textAlign: "center",

    "& .bodyContent": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
  "& .getStart" : {
    fontWeight: 700,
    color:'var(--dark_blue)', 
    height:'unset !important',
    fontSize:'15px',
    marginTop:'8px'  
  },

  "& .actionButton": {
    backgroundColor: "#3E50F7",
    minWidth: 130,
    marginLeft: "10px",
    color:'#FFF',
    "&:hover, &:focus": {
      backgroundColor: "#3E50F7",
    },
  },

  "& .closeButton": {
    minWidth: 130,
    border: "1px solid #3E50F7",
    color: "#3E50F7","&:hover, &:focus": {
      backgroundColor: "transparent",
    },

  },

  "& .modalFooter": {
    padding: 16,
    display: "flex",
    justifyContent: "center",
  },
}));

const GetStarted = ({ setStep, onClose }) => {
  return (
    <Wrapper className="contentWrapper">
      <div className="modalHeader">
        <div className="titleWrapper">
          <img
            src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/phone-number-popup.png`}
            height="50px"
            alt="logo"
          />
          <Typography style={{height:'unset !important'}} className={"titleHeader"}>Phone Settings</Typography>
        </div>
      </div>

      <div className="modalBody">
        <div className="bodyContent">
          <div>
            <Typography style={{height:'unset !important'}}>
              To enable the phone and texting functionality, <br /> you first
              need to add a phone number
            </Typography>
            <Typography className="getStart">
              Click the next button to get started
            </Typography>
          </div>
        </div>
      </div>

      <div className="modalFooter">
        <Button
            variant="outlined"
            color="primary"
            className={"closeButton"}
            disableElevation
            onClick={()=>{onClose()}}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={"actionButton"}
          disableElevation
          onClick={()=>{setStep(STEP_TABS.SELECT_NUMBER)}}
        >
          Next
        </Button>
      </div>
    </Wrapper>
  );
};

export default GetStarted;
